import { Component, inject } from '@angular/core';
import { BasicForm } from '@shared/components/classes/basic.form';
import { DefaultService } from '@common/references/default.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputValidatorDirective } from '@common/directive/input-validator.directive';
import { PasswordModule } from '@primeng/password';
import { InputNumberModule } from '@primeng/inputnumber';
import { CalendarModule } from '@primeng/calendar';
import { DropdownModule } from '@primeng/dropdown';
import { MultiSelectModule } from '@primeng/multiselect';
import { CheckboxModule } from '@primeng/checkbox';
import { RadioButtonModule } from '@primeng/radiobutton';
import { SliderModule } from '@primeng/slider';
import { InputSwitchModule } from '@primeng/inputswitch';
import { InputTextareaModule } from '@primeng/inputtextarea';
import { ColorPickerModule } from '@primeng/colorpicker';
import { ChipsModule } from '@primeng/chips';
import { InputMaskModule } from '@primeng/inputmask';
import { FloatLabelModule } from '@primeng/floatlabel';
import { ToggleButtonModule } from "@primeng/togglebutton";
import { TranslatePipe } from '@ngx-translate/core';
import { MeterTypeService } from '@modules/settings/meter-type/meter-type.service';
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from "@ng-select/ng-select";
import { AutocompleteComponent } from "@shared/components/autocomplete/autocomplete.component";
import { UtilityProviderTypesService } from '@modules/settings/utility-types/utility-provider-types.service';
import { UtilityProvidersService } from '@modules/settings/utility-providers/utility-providers.service';

@Component({
  selector: 'app-meter-type-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    InputValidatorDirective,
    PasswordModule,
    InputNumberModule,
    CalendarModule,
    DropdownModule,
    MultiSelectModule,
    CheckboxModule,
    RadioButtonModule,
    SliderModule,
    InputSwitchModule,
    InputTextareaModule,
    ColorPickerModule,
    ChipsModule,
    InputMaskModule,
    FloatLabelModule,
    ToggleButtonModule,
    TranslatePipe,
    NgOptionTemplateDirective,
    NgSelectComponent,
    NgLabelTemplateDirective,
    AutocompleteComponent
  ],
  templateUrl: './meter-type-form.component.html',
  styleUrl: './meter-type-form.component.scss',
})
export class MeterTypeFormComponent extends BasicForm<any> {
  _defaultService: DefaultService<any> = inject(MeterTypeService);
  form: FormGroup;
  dateFields = ['manufactureDate'];
  utilityProviderTypesService = inject(UtilityProviderTypesService);
  utilityProvidersService = inject(UtilityProvidersService);

  constructor(private fb: FormBuilder) {
    super();
    this.form = this.fb.group({
      code: ['', [Validators.required, Validators.maxLength(7)]],
      name: ['', [Validators.required]],
      model: ['', [Validators.required]],
      manufacture: ['', [Validators.required]],
      manufactureDate: ['', [Validators.required]],
      utilityProviderId: [null, [Validators.required]],
      utilityProviderTypeId: [null, [Validators.required]],
      capacity: ['', [Validators.required]],
      certification: [true, [Validators.required]],
      certificationBody: ['', [Validators.required]],
      status: [true],
    });
  }
  patchResponseData(res: any) {
    res.utilityProviderId = res.utilityProviderType?.utilityProviderId;
    super.patchResponseData(res);
  }
}
